import { ButtonBase, useTheme } from "@mui/material";

export const enum QualifyingOrderPurchaseType {
  InStoreAndOnline = "*",
  OnlineOnly = "ONLINE",
  InStoreOnly = "STORE",
}

export const DealTypeButton = ({
  type = QualifyingOrderPurchaseType.OnlineOnly,
  onPress,
}: {
  type?: QualifyingOrderPurchaseType;
  onPress: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  const theme = useTheme();

  const getText = () => {
    if (type === QualifyingOrderPurchaseType.InStoreAndOnline) {
      return "Online & in-store";
    } else if (type === QualifyingOrderPurchaseType.OnlineOnly) {
      return "Online";
    } else if (type === QualifyingOrderPurchaseType.InStoreOnly) {
      return "In-store";
    }

    return type;
  };

  const text = getText();

  return (
    <ButtonBase
      onClick={onPress}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        alignSelf: "flex-start",
        zIndex: 4,
        backgroundColor: theme.vars.palette.background.alternate,
        paddingLeft: 1,
        paddingRight: 1,
        paddingTop: 0.25,
        paddingBottom: 0.25,
        borderRadius: 2.5,
        border: "none",
        cursor: "pointer",
        textTransform: "none",
        minWidth: "auto",
        "&:hover": {
          backgroundColor: theme.vars.palette.background.alternate,
        },
      }}
    >
      <span
        style={{
          textAlign: "center",
          fontFamily: theme.typography.fontFamily,
          fontSize: 11,
          lineHeight: 1.6,
          color: theme.vars.palette.primary.main,
          fontWeight: 600,
        }}
      >
        {text}
      </span>
    </ButtonBase>
  );
};
